import React, { useRef, useState } from "react";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import Input from "@mui/joy/Input";
import Stack from "@mui/joy/Stack";
import CardActions from "@mui/joy/CardActions";
import CardOverflow from "@mui/joy/CardOverflow";
import "react-international-phone/style.css";
import { Button } from "primereact/button";
import { Grid } from "@mui/material";
import IntervalDropdown from "../../components/IntervalDropdown";
import MultiDropdownApi from "../../components/MultiDropdownApi";
import { TabPanel, TabView } from "primereact/tabview";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { Dropdown } from "primereact/dropdown";
import { FREQUENCIES } from "../forms-allocation/constants";
import { addRiskTaskCategory, updateRiskTaskCategory } from "../../service/JobTaskCategoryService";
export default function JobTaskCategoryAdd(modalProps: any) {
  const details = modalProps?.details;

  const [name, setName] = useState(details?.name || "");
  const [nameError, setNameError] = useState(false);
  const [industry, setIndustry] = useState(details?.industry || null);

  async function addIndustry() {
    setNameError(!name || name === "");
    if (!name || name === "") {
      modalProps.toast.current.show({
        severity: "warn",
        summary: "Please enter all required fields",
        life: 3000,
      });
      return;
    }
    const updateDetails = {
      name,
      industry,
    };
    if (modalProps.id) {
      updateRiskTaskCategory(modalProps.id, updateDetails).then((r: any) => {
        modalProps.toast.current.show({
          severity: "success",
          summary: "Scope Based Category Updated Successfully",
          life: 3000,
        });
        modalProps.setVisible(false);
        modalProps.setGlobalLoading(false);
        modalProps.setReload(!modalProps.reload);
      });
    } else {
      addRiskTaskCategory(updateDetails).then((r: any) => {
        modalProps.toast.current.show({
          severity: "success",
          summary: "Scope Based Category Created Successfully",
          life: 3000,
        });
        modalProps.setVisible(false);
        modalProps.setGlobalLoading(false);
        modalProps.setReload(!modalProps.reload);
      });
    }
  }

  return (
    <React.Fragment>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormControl error={nameError} sx={{ display: { sm: "flex-column", md: "flex-row" } }}>
            <FormLabel>
              Scope Based Task Category<div style={{ color: "red" }}>*</div>
            </FormLabel>
            <Input
              value={name}
              size="sm"
              placeholder="Category"
              onChange={e => setName(e.target.value)}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <MultiDropdownApi
            showAll={true}
            required={true}
            apiPath="industry"
            optionLabel="name"
            optionValue="id"
            label="Industry"
            selectedData={industry}
            setSelectedData={setIndustry}
          />
        </Grid>
      </Grid>
      <br />
      <br />
      <CardOverflow
        style={{ width: "100%" }}
        sx={{ borderTop: "1px solid", borderColor: "divider" }}
      >
        <CardActions style={{ marginTop: 15 }} sx={{ alignSelf: "flex-end", pt: 2 }}>
          <Button
            name="button"
            icon="pi pi-save"
            label="Save"
            className="p-button-outlined"
            size="small"
            style={{
              position: "absolute",
              fontSize: "small",
              right: 0,
              color: "#2dd36f",
            }}
            onClick={() => addIndustry()}
          />
        </CardActions>
      </CardOverflow>
    </React.Fragment>
  );
}
